module.exports = __webpack_public_path__ + "static/img/logo.16999ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = bPD/
// module chunks = 42